export enum CCPaymentRouteName {
    Index = 'finance.ccPayments.index',
}

export default {
    path: 'cc-payments',
    name: CCPaymentRouteName.Index,
    component: () => import('@/views/finance/cc-payment/Index.vue'),
    meta: {
        label: 'CC Payments',
        auth: true,
        permission: 'manage-payments',
        icon: 'fal fa-file-invoice-dollar fa-fw',
        location: 'sidebar',
        parent: 'finance',
    },
}
